'use client';

import { PAGE_SIZE, PAGE_PARAM } from '@/constants/paginationConstants';
import { usePathname, useSearchParams } from 'next/navigation';
import { prepareUrl } from '@/utils/urlHelper';
import { usePagination } from '@/hooks/usePagination';
import type { Url } from 'next/dist/shared/lib/router/router';
import { useCallback } from 'react';
import Pagination from '@/components/shared/pagination/Pagination';
import type { Locale } from '@/i18n';

export interface Props {
  totalCount: number;
  currentPage: number;
  searchTerm: string;
  locale: Locale;
  strings: {
    pagination_aria_label: string;
    pagination_previous_icon_aria_label: string;
    pagination_next_icon_aria_label: string;
    page_number_aria_label: string;
  };
}

export default function PaginationContainer({
  totalCount,
  currentPage,
  searchTerm,
  locale,
  strings
}: Props): JSX.Element | null {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize: PAGE_SIZE
  });
  const onPressHandler = useCallback(
    (page: number): Url => prepareUrl(pathname, searchParams, { key: PAGE_PARAM, value: page.toString() }),
    [pathname, searchParams]
  );

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  return (
    <Pagination
      selected={currentPage}
      searchTerm={searchTerm}
      onPress={onPressHandler}
      paginationRange={paginationRange}
      strings={strings}
      locale={locale}
    />
  );
}
